/** Feature-flagged ad pixel config. Never loads without ID + ENABLED=true. */

const truthy = (v: unknown) => String(v ?? '').toLowerCase() === 'true';

export const adPixelsConfig = {
  requireConsent: truthy(import.meta.env.VITE_ADS_REQUIRE_CONSENT ?? 'true'),
  meta: {
    id: (import.meta.env.VITE_META_PIXEL_ID as string | undefined)?.trim() || '',
    enabled: truthy(import.meta.env.VITE_META_PIXEL_ENABLED),
  },
  tiktok: {
    id: (import.meta.env.VITE_TIKTOK_PIXEL_ID as string | undefined)?.trim() || '',
    enabled: truthy(import.meta.env.VITE_TIKTOK_PIXEL_ENABLED),
  },
  googleAds: {
    id: (import.meta.env.VITE_GOOGLE_ADS_ID as string | undefined)?.trim() || '',
    enabled: truthy(import.meta.env.VITE_GOOGLE_ADS_ENABLED),
    purchaseLabel:
      (import.meta.env.VITE_GOOGLE_ADS_PURCHASE_LABEL as string | undefined)?.trim() || '',
  },
} as const;

export function isMetaActive() {
  return adPixelsConfig.meta.enabled && !!adPixelsConfig.meta.id;
}
export function isTikTokActive() {
  return adPixelsConfig.tiktok.enabled && !!adPixelsConfig.tiktok.id;
}
export function isGoogleAdsActive() {
  return adPixelsConfig.googleAds.enabled && !!adPixelsConfig.googleAds.id;
}
